import axiosInstance from "../../../axios/axios";

export function getAuctionById(id) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auction/id?Id=${id}`).then(response => {
            if (response.status == 200) {
                if (response.data.status?.responseCode == "200") {
                    const res = response?.data?.result;
                    resolve(res ?? {})
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function enrollBidder(auctionId, userID, isBiddForOthers) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(
            "/bidders/enrollbidder",
            {
                UserId: userID,
                EnrolledAuctionId: auctionId,
                DepositPayment: "EnrollWithPayment",
                PaymentStatus: "Paid",
                PaymentMethod: "OnlinePayment",
                BidderFiles: "",
                IsBidForOthers: isBiddForOthers
            },
            {
                headers: {
                    "content-type": "multipart/form-data",
                },
            }
        ).then(response => {
            if (response.data.status?.responseCode == "200") {
                const paymentURL = response.data?.result?.url;
                resolve(paymentURL ?? false)
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function getHorseListByAuctionId(aucitonId, status, skip, take) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auction/getauctionhorsesbyid?Id=${aucitonId}&SellingStatus=${status}&skip=${skip}&take=${take}`).then(response => {
            if (response.data?.responseCode == "200") {
                const res = response?.data;
                resolve(res ?? {});
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

// export function getauctionwithhorse(aucitonId, horseId = "") {
//     return new Promise((resolve, reject) => {
//         axiosInstance.get(`/auction/getauctionwithhorse?Id=${aucitonId}&auctionHorseId=${horseId}`).then(response => {
//             if (response.status == 200) {
//                 const formattedData = {
//                     name: response?.data?.name,
//                     type: response?.data?.typeText ,
//                     startDate: new Date(response?.data?.startDate),
//                     endDate: new Date(response?.data?.endDate),
//                     liveUrl: response?.data?.liveUrl,
//                     introVideoUrl: response?.data?.introVideoUrl,
//                     bidderId: response?.data?.bidderId,
//                     fees: response?.data?.auctionFees,
//                     isEnrollOpened: response?.data?.isEnrollOpened,
//                     isUserEnrolled: response?.data?.isUserEnrolled,
//                     isAuctionedOneByOne: response?.data?.isAuctionedOneByOne,
//                     isOnlineBiddingEnabled: response?.data?.isOnlineBiddingEnabled,
//                     isAuctionLive: response?.data?.isAuctionLive,
//                     horse: response?.data?.horseAuctionsDto,
//                     termsAndConditions: response?.data?.termsAndConditionsTextEn,
//                     termsAndConditionsAr: response?.data?.termsAndConditionsTextAr,
//                     horseCount: response?.data?.horseCount,
//                     bidderNumber:response?.data?.bidderNumber,
//                     horseSellingStatus:response?.data?.bidderNumber,
//                 }

//                 resolve(formattedData ?? {});
//             }
//             resolve(false);
//         }).catch(error => reject(false))
//     })
// }
export function getauctionwithhorse(aucitonId, horseId = "") {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auction/getauctionwithhorse?Id=${aucitonId}&auctionHorseId=${horseId}`).then(response => {
            if (response.data?.responseCode == '200') {
                const formattedData = {
                    name: response?.data?.result?.name,
                    type: response?.data?.result?.typeText ,
                    startDate: new Date(response?.data?.result?.startDate),
                    endDate: new Date(response?.data?.result?.endDate),
                    liveUrl: response?.data?.result?.liveUrl,
                    introVideoUrl: response?.data?.result?.introVideoUrl,
                    bidderId: response?.data?.result?.bidderId,
                    fees: response?.data?.result?.auctionFees,
                    isEnrollOpened: response?.data?.result?.isEnrollOpened,
                    isUserEnrolled: response?.data?.result?.isUserEnrolled,
                    isAuctionedOneByOne: response?.data?.result?.isAuctionedOneByOne,
                    isOnlineBiddingEnabled: response?.data?.result?.isOnlineBiddingEnabled,
                    isAuctionLive: response?.data?.result?.isAuctionLive,
                    horse: response?.data?.result?.horseAuctionsDto,
                    termsAndConditions: response?.data?.result?.termsAndConditionsTextEn,
                    termsAndConditionsAr: response?.data?.result?.termsAndConditionsTextAr,
                    horseCount: response?.data?.result?.horseCount,
                    bidderNumber:response?.data?.result?.bidderNumber,
                    horseSellingStatus:response?.data?.result?.bidderNumber,
                    logo:response?.data?.result?.logo,
                    featureImage:response?.data?.result?.featureImage,

                }

                resolve(formattedData ?? {});
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}